import dynamic from "next/dynamic";

const BlogBanner = dynamic(() => import("./banner"), { ssr: true });
const BlogPost = dynamic(() => import("./blog-post"), { ssr: true });
const BlogSuccess = dynamic(() => import("./success"), { ssr: true });

interface BlogProps {
  data: any[];
  slug: string;
}

const BlogPage: React.FC<BlogProps> = ({ data }) => {
  const blocks = data;

  return (
    <>
      {blocks?.length > 0 && (
        <div className="middle-sction blog-page-section bg-one">
          {blocks.map((block, i) => {
            return (
              <div key={i}>
                {block.__component === "blocks.banner" && (
                  <BlogBanner data={block} />
                )}
                {block.__component === "blocks.blogs" && (
                  <div id="tabs">
                    <BlogPost data={blocks} />
                  </div>
                )}
                {block.__component === "blocks.cta" && (
                  <BlogSuccess data={block} />
                )}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default BlogPage;
